import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import onClickOutside from 'react-onclickoutside';

@onClickOutside
export class GeozoneOptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleClickOutside = () => {
    this.setState({
      open: false,
    });
  };
  handleEditClick = () => {
    this.props.handleEdit();
    this.setState({
      open: false,
    });
  };
  handleRemoveClick = () => {
    this.props.handleRemove();
    this.setState({
      open: false,
    });
  };
  render() {
    const { editText, removeText } = this.props;
    return (
      <div className="dropup">
        <i role="button" tabIndex={0} className="dropup__button icon-dots" onClick={() => { this.setState({ open: !this.state.open }); }} />
        <div className={cx('dropup__container', { dropup__container_state_open: this.state.open })}>
          <ul className="list">
            <li className="list__item">
              <a tabIndex={0} role="button" className="link" onClick={this.handleEditClick}>{editText}</a>
            </li>
            <li className="list__item">
              <a tabIndex={-1} role="button" className="link link_action_remove" onClick={this.handleRemoveClick}>{removeText}</a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

GeozoneOptions.propTypes = {
  editText: PropTypes.string.isRequired,
  removeText: PropTypes.string.isRequired,
  handleEdit: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/Geozones/Options.js